/* CSN product page (v8): sold-out choices hidden in the variant picker, stock pill refresh on variant change,
   breadcrumb that follows the shopper's path, mobile sticky add to cart bar. Loaded (deferred) by sections/main-product.liquid. Dawn's product form does the real work. */
(function () {
  'use strict';

  /* ---------- 0. Variant picker: only available choices ----------
     snippets/csn-variant-picker.liquid renders only values that have an available variant (given the values
     chosen before them) and puts all variants in [data-csn-variants]. When a value changes we fix the next
     options at once (before Dawn reads them), so Dawn asks for an available variant and the lists update
     without waiting for the server. On load, a sold-out selected variant (for example from ?variant=) moves
     to the first available one. */
  function vsData(vs) {
    var wrap = vs.closest('.csn-buy') || vs.parentNode;
    var el = wrap && wrap.querySelector('script[data-csn-variants]');
    if (!el) return null;
    if (!el._csn) {
      try { el._csn = JSON.parse(el.textContent); } catch (e) { return null; }
    }
    return el._csn;
  }
  function ctrlFor(vs, i) {
    return vs.querySelector('select[data-csn-option="' + i + '"], fieldset[data-csn-option="' + i + '"]');
  }
  function ctrlValue(ctrl) {
    if (!ctrl) return null;
    if (ctrl.tagName === 'SELECT') return ctrl.value;
    var input = ctrl.querySelector('input');
    return input ? input.value : null;
  }
  function allowedFor(d, i, chosen) {
    var names = {};
    d.variants.forEach(function (v) {
      if (!v.available) return;
      for (var k = 0; k < i; k++) if (v.options[k] !== chosen[k]) return;
      names[v.options[i]] = true;
    });
    return d.options[i].values.filter(function (x) { return names[x.name]; });
  }
  function setCtrl(ctrl, vals, value) {
    if (!ctrl || !vals.length) return;
    if (ctrl.tagName === 'SELECT') {
      ctrl.innerHTML = '';
      vals.forEach(function (x) {
        var o = document.createElement('option');
        o.value = x.name;
        o.textContent = x.name;
        o.dataset.optionValueId = x.id;
        if (x.name === value) { o.setAttribute('selected', 'selected'); o.selected = true; }
        ctrl.appendChild(o);
      });
    } else {
      var hit = vals.filter(function (x) { return x.name === value; })[0] || vals[0];
      var input = ctrl.querySelector('input');
      var text = ctrl.querySelector('[data-csn-fixed-value]');
      if (input) { input.value = hit.name; input.dataset.optionValueId = hit.id; input.checked = true; }
      if (text) text.textContent = hit.name;
    }
  }
  // Keep options after index i valid for the values chosen up to i.
  function settleAfter(vs, d, i) {
    var n = d.options.length;
    var chosen = [];
    for (var k = 0; k <= i; k++) chosen.push(ctrlValue(ctrlFor(vs, k)));
    for (var j = i + 1; j < n; j++) {
      var ctrl = ctrlFor(vs, j);
      var vals = allowedFor(d, j, chosen);
      var cur = ctrlValue(ctrl);
      if (vals.length && !vals.some(function (x) { return x.name === cur; })) cur = vals[0].name;
      setCtrl(ctrl, vals, cur);
      chosen.push(cur);
    }
  }
  // Make the "selected" attribute match the live value on every csn select (Dawn's markup reads option[selected]).
  function syncSelectedAttrs(vs) {
    vs.querySelectorAll('select[data-csn-option]').forEach(function (s) {
      var v = s.value;
      Array.prototype.forEach.call(s.options, function (o) {
        if (o.value === v) { o.setAttribute('selected', 'selected'); o.selected = true; } else { o.removeAttribute('selected'); }
      });
    });
  }
  function valueId(d, i, name) {
    var hit = d.options[i] && d.options[i].values.filter(function (x) { return x.name === name; })[0];
    return hit ? String(hit.id) : null;
  }
  /* We own the option change. Dawn's own handler builds the request from option[selected] attributes, and on
     iPhone Safari those can still point at the OLD choice when the change fires, so the page asked the server
     for the old size and "flicked back". Here we stop Dawn's handler, settle the later options to an available
     choice, and publish the exact option value ids from the product data. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'SELECT' || !t.hasAttribute('data-csn-option')) return;
    var vs = t.closest('variant-selects');
    var d = vs && vsData(vs);
    if (!d || typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return; // fall back to Dawn
    e.stopImmediatePropagation();
    var i = parseInt(t.getAttribute('data-csn-option'), 10);
    var picked = t.value; // read the shopper's choice first, before any DOM change
    settleAfter(vs, d, i);
    // Remember every intended value, then fix the [selected] attributes, then put the values back.
    // (Safari can reset a select to its first option when a [selected] attribute is removed.)
    var want = [];
    for (var k = 0; k < d.options.length; k++) want.push(k === i ? picked : ctrlValue(ctrlFor(vs, k)));
    syncSelectedAttrs(vs);
    for (var m = 0; m < d.options.length; m++) {
      var c = ctrlFor(vs, m);
      if (c && c.tagName === 'SELECT' && c.value !== want[m]) {
        c.value = want[m];
        Array.prototype.forEach.call(c.options, function (o) {
          if (o.value === want[m]) o.setAttribute('selected', 'selected');
        });
      }
    }
    var ids = [];
    for (var n = 0; n < want.length; n++) {
      var id = valueId(d, n, want[n]);
      if (id) ids.push(id);
    }
    if (ids.length !== d.options.length) return;
    // Dawn focuses document.querySelector('#' + target.id) after the update. Focusing a <select> on iPhone
    // re-opens its picker, so give Dawn the (not focusable) variant-selects element's id instead.
    t.blur();
    publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: { event: e, target: { id: vs.id || '', dataset: {} }, selectedOptionValues: ids }
    });
  }, true);

  // Best available variant for the values chosen now: keeps the longest run of leading choices
  // (Size first, then Flavour), so a size change keeps the size and only moves the flavour.
  function bestAvailable(d, chosen) {
    var best = null, bestScore = -1;
    d.variants.forEach(function (v) {
      if (!v.available) return;
      var score = 0;
      for (var k = 0; k < chosen.length; k++) { if (v.options[k] === chosen[k]) score++; else break; }
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  }
  // If the variant Dawn shows is sold out (or missing) while others are in stock, move every control to the
  // best available variant and fire one change so Dawn updates price, image, URL, form id and buttons.
  var repairs = 0;
  function repair(vs) {
    if (!vs || repairs > 4) return;
    var d = vsData(vs);
    var selEl = vs.querySelector('[data-selected-variant]');
    if (!d || !selEl) return;
    var sel = null;
    try { sel = JSON.parse(selEl.textContent); } catch (e) { /* keep null */ }
    if (sel && sel.available) { repairs = 0; return; }
    var chosen = [];
    for (var i = 0; i < d.options.length; i++) chosen.push(ctrlValue(ctrlFor(vs, i)));
    var target = bestAvailable(d, chosen);
    if (!target) return;
    repairs++;
    var trigger = null;
    for (var j = 0; j < d.options.length; j++) {
      var ctrl = ctrlFor(vs, j);
      setCtrl(ctrl, allowedFor(d, j, target.options.slice(0, j)), target.options[j]);
      if (!trigger && ctrl && ctrl.tagName === 'SELECT') trigger = ctrl;
    }
    if (trigger) {
      trigger.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', target.id);
      window.location.replace(url.toString());
    }
  }
  function moveOffSoldOut() {
    document.querySelectorAll('product-info variant-selects.csn-vs').forEach(function (vs) {
      if (vs.offsetParent === null && vs.style.display === 'none') return;
      repair(vs);
    });
  }
  var movedOnce = false;
  function moveOnce() {
    if (movedOnce) return;
    movedOnce = true;
    // Let Dawn's product-info element connect first (it is defined by a later deferred script).
    setTimeout(moveOffSoldOut, 0);
  }
  if (document.readyState === 'complete') moveOnce();
  else {
    document.addEventListener('DOMContentLoaded', moveOnce);
    window.addEventListener('load', moveOnce);
  }

  /* ---------- Breadcrumb follows the shopper's path ----------
     The server renders the URL collection or the product's main category (snippets/csn-pdp-crumbs.liquid).
     If the URL has no collection, use the last collection the shopper opened (snippets/csn-last-collection.liquid),
     but only when this product is in it. */
  function crumbs() {
    var dataEl = document.getElementById('CsnCrumbData');
    if (!dataEl) return;
    var data, last;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || data.fromUrl || /\/collections\/[^/]+\/products\//.test(window.location.pathname)) return;
    try { last = JSON.parse(window.sessionStorage.getItem('csn:lastCollection') || 'null'); } catch (e) { return; }
    if (!last || !last.handle || !last.title) return;
    if (last.handle === 'all' || last.handle === 'all-stock') return;
    if (!data.handles || data.handles.indexOf(last.handle) === -1) return;
    var url = last.url || '/collections/' + last.handle;
    document.querySelectorAll('[data-csn-crumb-cat]').forEach(function (li) {
      var a = li.querySelector('a');
      if (!a) return;
      a.setAttribute('href', url);
      a.textContent = last.title;
      li.hidden = false;
    });
  }
  crumbs();

  function init() {
    var root = document.querySelector('product-info[id^="MainProduct-"]');
    if (!root || root.closest('quick-add-modal')) return;
    var sid = root.dataset.section;
    var bar = document.getElementById('CsnSticky-' + sid);
    var stock = document.getElementById('CsnStock-' + sid);
    var strings = window.variantStrings || {};

    function mainBtn() {
      return document.getElementById('ProductSubmitButton-' + sid);
    }
    var EMAIL_SEL = '.shopify-app-block input[type="email"], .shopify-app-block input[placeholder*="email" i], .shopify-app-block input[name*="email" i]';
    function notifyBlock() {
      // Back-in-stock app form (any app block in the product info with an email field), if the app shows one.
      var input = root.querySelector(EMAIL_SEL);
      var blockEl = input && input.closest('.shopify-app-block');
      return blockEl && blockEl.offsetParent !== null ? blockEl : null;
    }
    function picker() {
      return root.querySelector('variant-selects') || root.querySelector('.product-form__quantity');
    }

    // 1. Variant change: copy the fresh stock pill and sticky text from the HTML Dawn already fetched.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var data = evt && evt.data;
        if (!data || data.sectionId !== sid || !data.html) return;
        ['CsnStock', 'CsnStickyInfo'].forEach(function (id) {
          var src = data.html.getElementById(id + '-' + sid);
          var dest = document.getElementById(id + '-' + sid);
          if (src && dest) dest.innerHTML = src.innerHTML;
        });
        // Never stay on a sold-out choice when another one is in stock.
        setTimeout(function () { repair(root.querySelector('variant-selects.csn-vs')); }, 0);
      });
    }

    // 2. Sticky bar button mirrors the main add to cart button.
    if (!bar) return;
    var btn = bar.querySelector('[data-csn-sticky-btn]');
    var state = 'add';

    function sync() {
      var b = mainBtn();
      if (!b) return;
      var label = (b.querySelector('span') || b).textContent.trim();
      var disabled = b.hasAttribute('disabled');
      var unavailable = disabled && strings.unavailable && label === strings.unavailable;
      if (unavailable) {
        state = 'choose';
        btn.textContent = 'Choose options';
        btn.disabled = false;
        if (stock) stock.innerHTML = '<span class="csn-pill csn-pill--out">Unavailable</span>';
        var info = document.getElementById('CsnStickyInfo-' + sid);
        if (info) {
          var price = info.querySelector('.csn-sticky__price');
          var v = info.querySelector('.csn-sticky__variant');
          if (v) v.textContent = 'This combination is not available';
          if (price) price.textContent = '';
        }
      } else if (disabled && notifyBlock()) {
        state = 'notify';
        btn.textContent = 'Notify me';
        btn.disabled = false;
      } else if (disabled) {
        state = 'soldout';
        btn.textContent = label || 'Sold out';
        btn.disabled = true;
      } else {
        state = 'add';
        btn.textContent = label || 'Add to cart';
        btn.disabled = false;
      }
      btn.classList.toggle('is-loading', b.getAttribute('aria-disabled') === 'true' && !disabled);
    }

    btn.addEventListener('click', function () {
      var b = mainBtn();
      if (state === 'add' && b && !b.hasAttribute('disabled')) {
        b.click();
      } else {
        var p = state === 'notify' ? notifyBlock() : picker();
        if (p) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          p.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          var first = state === 'notify' ? p.querySelector('input[type="email"], input[placeholder*="email" i], input[name*="email" i]') : p.querySelector('input:checked, select, input');
          if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 400);
        }
      }
    });

    var b0 = mainBtn();
    if (b0) {
      new MutationObserver(sync).observe(b0, { attributes: true, childList: true, subtree: true, characterData: true });
    }
    sync();
    window.addEventListener('load', sync);
    setTimeout(sync, 3000); // the back-in-stock app form can render late
    bar.hidden = false;

    // 3. Show the bar only after the main button has scrolled up out of view, and never over the footer.
    //    Checked on scroll (rAF-throttled, passive) so fast jumps (anchor links, restore scroll) are caught too.
    if (!b0) return;
    var footer = document.querySelector('footer, .footer, [id$="__footer"]');
    var ticking = false;
    var shown = null;
    function update() {
      ticking = false;
      var atcAbove = b0.getBoundingClientRect().bottom < 0;
      var footerSeen = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var show = atcAbove && !footerSeen;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
